// src/components/geral/PageFooter.js
import React from 'react';
import './PageFooter.css';

const PageFooter = ({children}) => {


  return (
    <div className="page-content-footer">
      <div className="page-content-footer-inner">
        {children}
      </div>
    </div>
  );
};

export default PageFooter;
